import { createAction } from 'redux-actions';
import { createProgressActions, createActionCreators } from '../utils';

const SET_ACCOUNT = "SET_ACCOUNT";
const setAccount = createAction(
    SET_ACCOUNT,
    ({ username, email, email_verified }) => ({ username, email, email_verified})
);
export { setAccount };

const fetch = createActionCreators(createProgressActions('FETCH_ACCOUNT'));
const post = createActionCreators(createProgressActions('POST_ACCOUNT'));
const changeEmail = createActionCreators(createProgressActions('CHANGE_EMAIL'));
const changePassword = createActionCreators(createProgressActions('CHANGE_PASSWORD'));

const CLEAR = 'CLEAR_ACCOUNT';
const clear = createAction(CLEAR, () => {});

const actions = {
     setAccount: SET_ACCOUNT,
     clear: CLEAR
};

export default actions;
export { fetch, post, changePassword, changeEmail, clear };



// WEBPACK FOOTER //
// ./src/app/models/Account/actions.ts